<template>
  <div>
    <div
      v-if="tipsText"
      class="ticket-tips"
    >
      <div
        v-for="(tip, index) in tipsText.split(';')"
        :key="index"
      >
        {{ tip }}
      </div>
    </div>
    <van-popup
      v-model="showSelectPoi"
      position="top"
      :style="{ height: '50%' }"
    >
      <van-search
        v-model="searchInfo.searchWord"
        placeholder="请输入门店名称"
        @input="onSearch"
      />
      <van-list
        v-if="!searchInfo.searchWord"
        v-model="poiPage.loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="poi in options"
          :key="poi.poiId"
          :title-class="{ 'checked-poi': currentPoi.poiId === poi.poiId }"
          :title="poi.poiName"
          @click="check(poi)"
        />
      </van-list>
      <van-list
        v-else
        v-model="searchInfo.searching"
        :finished="true"
      >
        <van-cell
          v-for="poi in searchInfo.searchPois"
          :key="poi.poiId"
          :title-class="{ 'checked-poi': currentPoi.poiId === poi.poiId }"
          :title="poi.poiName"
          @click="check(poi)"
        />
      </van-list>
    </van-popup>
    <div
      v-if="showPoi"
      :class="tipsText && 'tips-top'"
      class="titleBar-container"
    >
      <div
        class="select-poi"
        @click="showSelectPoi = true"
      >
        <span>{{ currentPoi.poiName }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div class="right-area">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DropdownMenu from 'vant/lib/dropdown-menu';
import DropdownItem from 'vant/lib/dropdown-item';
import 'vant/lib/dropdown-menu/style';
import 'vant/lib/dropdown-item/style';
import { debounce } from 'lodash';
import Store from '@/store/index';
import Poi from '@/api/poi';

export default {
  name: 'TitleBar',
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  props: {
    showPoi: {
      type: Boolean,
      default: true,
    },
    showAllPois: {
      type: Boolean,
      default: true,
    },
    tipsText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showSelectPoi: false,
      loadPoi: false,
      searchInfo: {
        /** 搜索的poi列表 */
        searchPois: [],
        /** 搜索的关键词 */
        searchWord: '',
        searching: false,
      },
    };
  },
  computed: {
    ...mapState(['currentPoi', 'poiList', 'signInfo', 'poiPage', 'searchPois']),
    options() {
      const pois = this.poiList.map((poi) => poi.poiId);
      if (!pois.includes(this.currentPoi.poiId)) {
        const searchs = this.searchPois.filter((poi) => poi.poiId === this.currentPoi.poiId);
        return searchs.concat(this.poiList.filter((poi) => poi.poiId || this.showAllPois));
      }
      return this.poiList.filter((poi) => poi.poiId || this.showAllPois);
    },
    finished() {
      return this.poiPage.pageNum > this.poiPage.pageCount;
    },
  },
  methods: {
    ...mapMutations(['setCurrentPoi']),
    onLoad() {
      Store.dispatch('fetchPoiData');
    },
    check(poi) {
      if (poi.poiId === this.currentPoi.poiId) {
        return;
      }
      this.setCurrentPoi(poi);
      this.showSelectPoi = false;
      this.$emit('poiChangeCallback');
    },
    onSearch: debounce(async function () {
      if (this.searchInfo.searchWord) {
        this.searchInfo.searching = true;
        const { data, respMsg, respCode } = await Poi.searchPoi({
          poiName: this.searchInfo.searchWord,
          pageSize: 200,
          pageNum: 1,
        });
        if (respCode !== 0) {
          this.$dialog.toast(respMsg);
        } else {
          this.searchInfo = {
            ...this.searchInfo,
            searchPois: data,
            searching: true,
          };
          Store.commit('setSearchPois', data);
        }
      }
    }, 1000),
  },
};
</script>

<style lang="scss" scoped>
.select-poi {
  float: left;
  height: 0.85rem;
  display: flex;
  align-items: center;
}
.ticket-tips {
  position: fixed;
  top: 0;
  padding: 10px 0;
  width: 100%;
  text-align: center;
  background: #fff;
  color: #fe8c00;
  z-index: 1;
}
.titleBar-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 85px;
  padding: 0 36px;
  background: #fff;
  color: rgba(0, 0, 0, 0.84);
  z-index: 10;
  .poi {
    position: absolute;
    box-sizing: border-box;
    left: 0;
    max-width: 490px;
    height: auto;
    padding: 24px 32px 24px 36px;
  }
  .right-area {
    position: absolute;
    right: 0;
    max-width: 248px;
    line-height: 37px;
    padding: 24px 26px 24px 36px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.tips-top {
  top: 80px;
  margin: 0 18px;
}
/deep/ .van-cell__value {
  flex: none;
  margin-left: 30px;
}
.checked-poi {
  color: #ed4f4f;
}
</style>
